<div class="modal-header">
  <h4 class="modal-title">Get Information by SMS/Email - {{C2CModel.BusinessName}}</h4>
  <a href="javascript:void(0)" style="color: black;" data-dismiss="modal">
    <i class="fa fa-times" aria-hidden="true"></i>
  </a>
</div>

<div class="modal-body">
  <form [formGroup]="ClickToCallForm" #c2cForm="ngForm" >
    <div class="form-group">
      <h5>Name*</h5>
      <input type="text" formControlName="EnquirerName" class="form-control">
      <span *ngIf="c2cForm.submitted && C2CForm.EnquirerName.errors" class="text-danger">
        <span *ngIf="C2CForm.EnquirerName.errors.required"> *required</span>
      </span>
    </div>
    <div class="form-group">
      <h5>Phone/Mobile*</h5>
      <input type="text" formControlName="EnquirerPhone" (keypress)="manikInteger($event);" maxlength="10" class="form-control">
      <span *ngIf="c2cForm.submitted && C2CForm.EnquirerPhone.errors" class="text-danger">
        <span *ngIf="C2CForm.EnquirerPhone.errors.required"> *required</span>
      </span>
    </div>
    <div class="form-group">
      <h5>Email*</h5>
      <input type="email" formControlName="EnquirerEmail" class="form-control">
      <span *ngIf="c2cForm.submitted && C2CForm.EnquirerEmail.errors" class="text-danger">
        <span *ngIf="C2CForm.EnquirerEmail.errors.required"> *required</span>
        <span *ngIf="C2CForm.EnquirerEmail.errors.email"> invalid email</span>
      </span>
    </div>
    <div class="form-group">
      <label class="checkbox_message">
        <input type="checkbox" checked formControlName="OKToContactBack"
               style="margin-left:0px">I authorize {{C2CModel.BusinessName}} and {{WebSiteMetaData.PC}} to contact me with the details provided
      </label>
      <span *ngIf="c2cForm.submitted && !C2CModel.AcceptTerms" class="text-danger">
        accept terms to proceed.
      </span>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div id="c2cForm" class="cManikgreCaptcha"></div>
        <span *ngIf="CaptchaInvalid" class="text-danger">
          <span> {{CaptchaMessage}}</span>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label id="lblRMessage" style="display: none;" class="alert alert-info"></label>
        <button type="submit" class="btn btn-primary" *ngIf="!C2CModel.IsSubmitted"
                (click)="C2CModel.IsSubmitted=true;SubmitForm();">
          Submit
        </button>
        <button class="btn btn-primary" *ngIf="C2CModel.IsSubmitted">
          <manik-button-loader></manik-button-loader>
        </button>
        <button type="button" class="btn btn-danger" (click)="cancel()" data-dismiss="modal">Close</button>
      </div>
    </div>
  </form>
  <!-- <app-visitor-handler *ngIf="!UserLoggedIn" [CountryID]="WebSiteMetaData.COUNTRYID" [PortalName]="WebSiteMetaData.PC" [PortalID]="WebSiteMetaData.PID" (visitorLoggedIn)="CheckUserLoggedIn();Emit();"></app-visitor-handler> -->
</div>
